var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeadershipIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.981 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".leadership_icon_svg__a,.leadership_icon_svg__b{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}.leadership_icon_svg__a{fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leadership_icon_svg__a",
    d: "M11.413 39.054V56.76A3.24 3.24 0 018.173 60a3.24 3.24 0 01-3.24-3.24V23.552"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leadership_icon_svg__a",
    d: "M31.01 3.519a2.463 2.463 0 010 3.467l-11.7 11.666a4.867 4.867 0 00-1.426 3.448v34.659a3.24 3.24 0 01-3.24 3.24 3.24 3.24 0 01-3.24-3.24V39.054"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leadership_icon_svg__a",
    d: "M31.011 3.52a2.463 2.463 0 00-3.467 0l-8.172 8.146a4.861 4.861 0 01-3.435 1.419H4.919A4.887 4.887 0 000 18.004v16.993a2.456 2.456 0 002.45 2.456 2.456 2.456 0 002.45-2.456v-15.69"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "leadership_icon_svg__b",
    cx: 4.563,
    cy: 4.563,
    r: 4.563,
    transform: "translate(6.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leadership_icon_svg__b",
    d: "M11.413 29.41v.823M11.413 23.72v1.653M11.413 18.036v1.646M11.413 13.111v.888M4.9 34.757h12.981M24.906 39.896h35.075M35.904 5.515H59.98M57.11 39.896V5.515M27.537 39.896v-23.72"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "leadership_icon_svg__b",
    cx: 3.163,
    cy: 3.163,
    r: 3.163,
    transform: "translate(39.281 46.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leadership_icon_svg__b",
    d: "M42.443 39.896v6.377M27.537 36.721l6.487-5.742 6.364 2.087 6.533-6.922 5.93 3.266 4.258-3.091M27.537 29.151l8.25-8.509 5.418.817 5.842-5.801 5.716.992 4.342-5.075"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeadershipIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leadership_icon.d57a7cab13451d576fc944fc033d2ee6.svg";